/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/ImageButton/index.js
 * Created:       Wed Mar 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React from "react";

export default function ImageButton({ label, name, onClick, type, fullWidth, subdued, id, image, disabled = false}) {
  return (
    <button
      type={type}
      id={id}
      onClick={onClick}
      className={`gc__button_image`}
      name={name}
      disabled={disabled}
    >
      <div className={"gc__button_image_container"}>
        {
          image ?
            <img className={"gc__icon"} src={image} alt="" />
            : <></>
        }
      </div>
      <div className={"gc__button_image_text"}>
        {label}
      </div>
    </button>
  )
}
